import { gql } from '@apollo/client';
import { PARKING_SESSION_FIELDS } from 'graphql/fields/parkingSessionFields';

export const READ_PARKING_SESSIONS = gql`
  ${PARKING_SESSION_FIELDS}
  query readParkingSessions($input: ReadParkingSessionsInput) {
    readParkingSessions(input: $input) {
      last
      content {
        ...ParkingSessionFields
      }
    }
  }
`;
